import axios from 'axios';
import getApiUrl from 'src/utils/get-api-url';

const apiUrl = getApiUrl();

/**
 * Get ETL last execution's datetime.
 * 
 * @returns {Promise<Object>}
 */
export function getETL() {
	return axios.get(`${apiUrl}/etl`);
}
